import { type PropsWithChildren, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';

import { createAppTheme } from '../../shared/config';
import { useViewportSize } from '../../shared/hooks/use-viewport-size';

type AppThemeProviderProps = PropsWithChildren;

export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const viewportSize = useViewportSize();
  const theme = useMemo(
    () => createAppTheme(viewportSize.width, viewportSize.height),
    [viewportSize.height, viewportSize.width],
  );

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
